import { CKEditor } from '@ckeditor/ckeditor5-react';
import React, { useEffect, useState } from 'react'
import Modal from 'react-modal';
import { sendEmails } from '../../utils/Network';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

function SendEmailModal({isOpen , name , onClose , to_email}) {

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [image, setImage] = useState(null);
    const [file, setFile] = useState(null);
    const [to, setTo] = useState(null);
    const [subject, setSubject] = useState(null);
    const [message, setMessage] = useState("");

    useEffect(() => {
        setModalIsOpen(isOpen)
        setTo(to_email)
    }, []);

    const closeModal = () => {
        setModalIsOpen(false)
        onClose();
    }

    const onChange = (e) => {
        //alert(e.target.name)
        switch (e.target.name) {
            case 'subject':
                setSubject(e.target.value)
                break;
                case 'to':
                    setTo(e.target.value)
                    break;
            case 'message':
                setMessage(e.target.value)
                break;
           
            default:

                break;
        }
    }
    const handleDescriptionChange = (data) => {
        setMessage(data)

    }

    const SaveChanges = () => {

        setError(null)

        if (!to) {
            setError("Please enter emails")
            return;
        }

        if (!subject) {
            setError("Please enter subject")
            return;
        }

        
        if (!message) {
            setError("Please enter message")
            return;
        }

        var emails = to.split(',')

        setLoading(true)
        sendEmails(emails, null, subject, message).then(data => {
            console.log(data)
            
            setLoading(false)
        })
    }

    

    return (
        <Modal
        closeTimeoutMS={500}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        className="Modal"
        overlayClassName="Overlay"
    >
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" onClick={closeModal}>
                    <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Send Email To {name}</h4>
            </div>
            <div class="modal-body text-center">
            
               <div className="">
                        <div >
                            <div className="">
                                
                                <div className="padding-10">
                                    <div className="form-group">
                                        <input type="text" disabled value={to} name="to" onChange={onChange} className="form-control dark-input " placeholder="To" />
                                    </div>
                                    <div className="form-group">
                                        <input type="text" value={subject} name="subject" onChange={onChange} className="form-control dark-input post-title" placeholder="Subject" />
                                    </div>
                                    <div className="form-group mb-15">
                                    <div className="form-group">
                                        <CKEditor
                                            editor={ClassicEditor}
                                            data={message}
                                            onReady={editor => {
                                                // You can store the "editor" and use when it is needed.
                                            }}
                                            onChange={(event, editor) => {
                                                const data = editor.getData();
                                                handleDescriptionChange(data)
                                            }}
                                        />
                                    </div>
                                    </div>
                                </div>
                              

                            </div>
                                {error &&
                                    <div className="alert alert-danger mt-5">
                                        {error}
                                    </div>
                                }
                                {loading &&
                                    <div className="alert alert-info  mt-5">
                                        Please Wait...
                                    </div>
                                }
                        </div>
                        </div>
                
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary pull-right" onClick={SaveChanges}>Send Emails</button>
                <a href={`emails`} className="btn btn-default pull-left">Cancel</a>
                               
            </div>

        </div>
    </Modal>
    )
}

export default SendEmailModal
